import React, { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { FiInfo } from "react-icons/fi";
import "./hm-theme.css";

const FamilyDisclaimerPopup = ({ isOpen, onRequestClose, memberid}) => {
  const [employeeDetails, setEmpDetails] = useState(null);
  const [compDetails, setCompanyDetails] = useState(null);
  const [designations, setDesignations] = useState(null);
  const [packageMapping, setPackageMapping] = useState(null);
  const [loader, setLoader] = useState(false);
  const [designationErrorModal, setDesignationErrorModal] = useState(false);
  const [packageMappingErrorModal, setPackageMappingErrorModal] = useState(false);
  
  const userid = JSON.parse(localStorage.getItem("data"))?.userid;
  const navigate = useNavigate();

  const handleBookAppointment = () => {
    navigate(`/users/bookAnAppointmentForFamilyMember/${memberid}`);
  };

  const getData = async () => {
    const token = JSON.parse(localStorage.getItem("data"))?.token;
    setLoader(true);
    try {
      const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEmpDetails(empRes.data);
      const compRes = await axios.get(`/api/companydetails/${empRes.data?.companyId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setCompanyDetails(compRes.data);
      const designationRes = await axios.get(`/api/employeedetails/checkDesignationMapped/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDesignations(designationRes.data);
     
      const packageRes = await axios.get(`/api/employeedetails/checkPackageMapped/userid=${userid}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPackageMapping(packageRes.data);

      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      } else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      } else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const allDetailsTrue =
    designations?.allAccounted === true &&
    packageMapping?.allAccounted === true; 
    
  const closeDesignationErrorModal = () => {
    setDesignationErrorModal(false);
  };

  const closePackageErrorModal = () => {
    setPackageMappingErrorModal(false);
  };

  return (
    <>
      <Modal show={isOpen} onHide={onRequestClose} centered size="md">
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h5 fw-bold mb-0 d-flex align-items-center gap-2" style={{ color: "#1e293b" }}>
            <i className="material-icons text-primary">family_restroom</i>
            Family Eligibility Check
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          {loader && <div className="loading"></div>}

          <h6 className="fw-bold mb-3" style={{ color: "#1e293b" }}>Eligibility Checklist</h6>
          
          <div className="d-flex align-items-center justify-content-between mb-2 p-2.5 rounded bg-light">
            <span className="small fw-semibold text-secondary">Designation</span>
            <div className="d-flex align-items-center gap-2">
              {designations?.allAccounted === true ? (
                <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2.5 py-1 rounded-pill small">✓ Verified</span>
              ) : (
                <>
                  <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2.5 py-1 rounded-pill small">❌ Pending</span>
                  <FiInfo className="text-primary cursor-pointer" onClick={() => setDesignationErrorModal(true)} />
                </>
              )}
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-between mb-2 p-2.5 rounded bg-light">
            <span className="small fw-semibold text-secondary">Package Mapping</span>
            <div className="d-flex align-items-center gap-2">
              {packageMapping?.allAccounted === true ? (
                <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 px-2.5 py-1 rounded-pill small">✓ Verified</span>
              ) : (
                <>
                  <span className="badge bg-danger bg-opacity-10 text-danger border border-danger border-opacity-25 px-2.5 py-1 rounded-pill small">❌ Pending</span>
                  <FiInfo className="text-primary cursor-pointer" onClick={() => setPackageMappingErrorModal(true)} />
                </>
              )}
            </div>
          </div>

          {!allDetailsTrue && (
            <div className="alert alert-danger p-2 mt-3 mb-0 small text-center rounded border-0">
              Please contact your administration for the pending requirements above.
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-3">
          <Button variant="outline-secondary" className="rounded-pill px-4 me-2" onClick={onRequestClose}>
            Decline
          </Button>
          {allDetailsTrue && (
            <button className="btn-hm-primary px-4" onClick={handleBookAppointment}>
              Accept
            </button>
          )}
        </Modal.Footer>
      </Modal>
    
      <Modal show={designationErrorModal} onHide={closeDesignationErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Designation Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{designations?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closeDesignationErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={packageMappingErrorModal} onHide={closePackageErrorModal} centered>
        <Modal.Header closeButton className="border-bottom px-4 py-3">
          <Modal.Title className="h6 fw-bold mb-0 text-danger">Package Mapping Error</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <p className="text-danger small mb-0">{packageMapping?.errorMessage}</p>
        </Modal.Body>
        <Modal.Footer className="border-top px-4 py-2">
          <Button variant="secondary" className="btn-sm rounded-pill px-3" onClick={closePackageErrorModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FamilyDisclaimerPopup;

